// OTO-020: shared source-of-truth strings for the piano/notation load error banners.
// Lives outside the component files so react-refresh/only-export-components stays happy
// (component files must only export components) and so the exact rendered text is
// unit-testable without mounting either component's tree.

export const PIANO_LOAD_ERROR_TEXT = 'Failed to load piano';
export const NOTATION_LOAD_ERROR_TEXT = 'Failed to load notation';

export function formatPianoTraceText(traceId: string): string {
  return `— trace: ${traceId}`;
}

export function formatNotationTraceText(traceId: string): string {
  return `— trace: ${traceId}`;
}
